<div>
  <div class="mt-6 mb-3 font-bold">
    <label>{{ 'notification-form.os' | translate }}</label>
  </div>
  <div
    class="flex w-full platform-buttons"
    [ngClass]="{
      'alert-border invalid-platform': platformControl?.invalid
    }"
  >
    <!-- iOS button -->
    @if (isIphoneReady$ | async) {
      <button
        [ngClass]="{
          'invalid-platform': platformControl?.invalid,
          'selected-platform': (platformControl?.value || []).includes('iphone')
        }"
        (click)="onTogglePlatform('iphone')"
      >
        iOS
      </button>
    } @else {
      <button
        rkTooltip
        [tooltipDescription]="iOSTooltipMessage | translate"
        [tooltipPosition]="'top'"
        [arrowPosition]="'right'"
        class="unavailable-platform"
      >
        <fa-icon [icon]="'lock'" class="text-sm mr-1"></fa-icon>iOS
      </button>
    }
    <!-- Android button -->
    @if (isAndroidReady$ | async) {
      <button
        [ngClass]="{
          'invalid-platform': platformControl?.invalid,
          'selected-platform': (platformControl?.value || []).includes('android')
        }"
        (click)="onTogglePlatform('android')"
      >
        Android
      </button>
    } @else {
      <button
        rkTooltip
        [tooltipDescription]="'notification-form.tooltip-unavailable-android' | translate"
        [tooltipPosition]="'top'"
        [arrowPosition]="'right'"
        class="unavailable-platform"
      >
        <fa-icon [icon]="'lock'" class="text-sm mr-1"></fa-icon>Android
      </button>
    }
  </div>
  <!-- Error message -->
  <div
    class="form-alert alert-text mt-1"
    [ngClass]="{
      'show-form-alert': platformControl?.invalid
    }"
  >
    <fa-icon [icon]="'warning'"></fa-icon>
    {{ 'notification-form.platform-error' | translate }}
  </div>
</div>
